import { defaultStateDataCurrent } from 'app/common/ui-components/filter'

const splitByDaysItems = (_, { splitByDays }: { splitByDays: boolean }) => {
  const currentState = splitByDays ? ['splitByDays'] : defaultStateDataCurrent

  return [
    [
      {
        id: 'splitByDays',
        title: 'Разбить период по дням',
      },
    ],
    currentState,
  ]
}

export default splitByDaysItems
